import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable, Pagination, Modal } from '../../secondary';
import { Confirmation } from '../../secondary/Confirmation/confirmation'
import { TextField, Button, SelectBox, RadioButton, AccessErrorModal } from '../../primary';
import Loader from '../../../static/images/spinner.svg';
import commonStyle from '../../../styles/common.module.scss';
import DeleteIcon from '../../../static/images/delete-icon.svg';
import searchIcon from '../../../static/images/search-icon.svg';
import PlusIcon from '../../../static/images/plus-icon_white.svg';
import warning from '../../../static/images/icon-check-danger.png';
import { CreatePatients } from '../../core/Patients/'
import { CreateCustomer } from '../../core/Customers/'
import { CreateUser } from '../../core/Users/'
import { CsvImportLoader } from '../../core/Patients/csvImportLoader'
import style from './listView.module.scss';
import { Header } from '../Header';
import { SimpleCreatePatient } from '../../core/Patients/simpleCreatePatient';
import { CsvImport } from '../CsvImport';
import { CreateForm } from '../../core/FormBuilder/'
import { CreateAnnouncement } from '../../core/Announcement/';
import { CreateListViewMenu } from '../../core/Layouts';
import { useDebounce } from '../../../utils';
import { CreateProductMaterial } from '../../core/Products';
import { useForm } from 'react-hook-form';
import { CreateSso } from '../../core/Users/createSso';
import {getFaciltiestUserAsyn, setUserFacilities, setCustomerNumberSearch, getCustomerNumberSuggestions} from '../../../app/userSlice'
import {checkFormularyNameStatus, setFormularyNameCheck} from '../../../app/formularySlice'
import InfoIcon from '../../../static/images/info.svg';
import constants from "../../../constants/constants.json";
import { useLocation, useNavigate } from 'react-router-dom';
import { useAdminView } from '../../../hooks/useAdminView';
import { useReadOnly } from '../../../hooks/useReadOnly';


export const ListView = ({ columns, data, metaData, sorting,
  rowSelect, getSelectedRowData, detailView, searchPlaceholder, getSearchValue, detailsRow,
  activePage, getActivePage, listSorting, listType, subHeading, facilityListView, fileUplodad,
  showFixedColumn, setUploadStatus, uploadingCheckAsync, deleteListView, searchKey, contextualSupportView,
  selectedFacility, getPatientList, formularyView, getSelectedItems, noPage, formularyLeft,
  handleProductChange, productType, setProductType, rightFormulary, addedItems, fixedFullWidthSize, offset, getCustomerList, getUserList,
  accessError, otherHeading, sortType, facilityNumberOption, pendingList, lockedList, openPend, openLock,patientListLastVal, manualPatientEnable,
  handleSearchColumn,searchColumns,setSearchColumns,setSearchKey, setActivePage, formularyNamePopup, setFormularyNamePopup, filterOnclick, clickImportExcel, setDuplicateNavigate, duplicateNavigate,
  showFormOption, setShowFormOption, clickManualCreation, handleClearFilter, enableClearFilter, isPending
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const patientLoad = useSelector(state => state.patient.patientLoad);
  /* Get url of the current page */
  const path = window.location.href;
  /* Below will return only domain - http://www.google.com */
  const origin = window.location.origin;
  
  const isAdminView = useAdminView();
  const isReadOnly = useReadOnly();
  const patientView = pathname.startsWith("/patients") || pathname.startsWith("/admin/patients")

  const [showClearX, setShowClearX] = useState(searchKey?true:false)

  // useEffect(() => {
  //   if (isAdminView) {
  //     dispatch(setAdminView("admin"));
  //   } else {
  //     dispatch(setAdminView("not"));
  //   }
  // }, [dispatch, isAdminView]);
  
  useEffect(() => {
    if (searchKey) {
      setShowClearX(true)
    }else{
      setShowClearX(false)
    }
  },[searchKey]);
  const [modalShow, setmodalShow] = useState(false)
  const [menuShow, setMenuShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("")
  const [onselectOrgz, setonselectOrg] = useState([]);
  const userRole = useSelector(state => state.user);

  // const facilityAndCustomerNumLastVal = useSelector(state => state.patient.facilityAndCustomerNumLastVal)
  //
  useEffect(()=>{
    dispatch(setFormularyNameCheck(false))
  },[])


  const { register, handleSubmit, control, errors, reset, setError, watch } = useForm();
  // const loading = useSelector(state => state.app.loading)
  // const adminView = useSelector(state => state.patient.adminView)

  const dropRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const handleClickOutside = (e) => {
    if (dropRef !== null && dropRef.current && !dropRef.current.contains(e.target)) {
      setMenuShow(false);      
    }
  };

  const menuList = () => {
    setMenuShow(true)
  }
  const modalOpen = () => {
    setmodalShow(true);
  }

  const modalClose = () => {
    setmodalShow(false);
    setConfirmationModal(false);    
  }

  // const getFacilities = useSelector(state => state.patient.facilitiesData);
  const getFacilities = useSelector(state => state.patient.newFacilitiesData);
  const [facOptionData, setFacOptionData] = useState('');


  // Resetting to blank when navigating between 
  // useEffect(() => {
  //   if(adminView === 'admin' && path.includes(`${origin}/admin`)){
  //     dispatch(setFacilityAndCustomerNumLastVal({customerNumber: ''}))
  //   }else if(adminView !== 'admin' && !path.includes(`${origin}/admin`)){
  //     dispatch(setFacilityAndCustomerNumLastVal({customerNumber: ''}))      
  //   }
  // }, [adminView])

  useEffect(() => {
    let fac = ""
    if (getFacilities?.errorMessage || getFacilities?.length === 0 &&document.getElementById('customerNumberId')&&document.getElementById('customerNumberId').value) {
      fac = "We didn’t recognize this customer number. Enter a different customer number"
    }
    setErrorMsg(fac)
    setFacOptionData(facilityNumberOption)
  }, [getFacilities,facilityNumberOption])

  const [selectedRowCount, setSelectedRowCount] = useState(0);
  const selectRowCount = (length) => {
    setSelectedRowCount(length)
  }

  let selectedData = "";
  const deleteDataList = (data) => {
    selectedData = data
    if (formularyView) {
      getSelectedItems(data)
    }

  }

  const deleteList = () => {
    deleteListView(selectedData);
    setConfirmationModal(false)
  }

  const [confirmationModal, setConfirmationModal] = useState(false)
  const deleteModal = () => {
    setConfirmationModal(true)
  }

  const handleSort = useCallback(data => {
    if (listSorting) {
      let sortingColumn = data.sortBy[0]
      let sortingType = sortingColumn ? (sortingColumn.desc) ? ':DESC' : ':ASC' : ''
      listSorting['queryParam']['sort'] = (sortingColumn) && sortingColumn.id + sortingType
      // The below if condition is for 'Sorting' + 'Pagination'  
      if (listSorting.setSortType) {
        //dispatch(listSorting.setSortType(listSorting['queryParam']['sort']))
        if(listSorting['queryParam']['sort']==undefined&&sortType){
          listSorting['queryParam']['sort']=sortType;
        }else{
          if(listSorting['queryParam']['sort']&&listSorting['queryParam']['sort']!==undefined){
            listSorting.setSortType(listSorting['queryParam']['sort'])
          }
        }
      }
      if(listType === 'Customers' &&Array.isArray(data?.sortBy)&&data?.sortBy.length>0){
        dispatch(listSorting.asyncMethod(listSorting));
      }else if(listType !== 'Customers'&& sortingColumn){
        dispatch(listSorting.asyncMethod(listSorting));
      }
    }

  }, [dispatch, searchKey, activePage, offset, sortType, searchColumns,patientLoad])

  const handleRightSort = useCallback(data => {
    if (listSorting) {
      let sortingColumn = data.sortBy[0]
      let sortingType = sortingColumn ? (sortingColumn.desc) ? ':DESC' : ':ASC' : ''
      listSorting['queryParam']['sort'] = (sortingColumn) && sortingColumn.id + sortingType
      if (!formularyView) {
        dispatch(listSorting.asyncMethod(listSorting));
      }
      if (formularyView) {
        listSorting.asyncMethod(sortingColumn)
      }
    }
  }, [dispatch, addedItems])

  const handleProductSort = useCallback(data => {
    if (listSorting) {
      let sortingColumn = data.sortBy[0]
      let sortingType = sortingColumn ? (sortingColumn.desc) ? ':DESC' : ':ASC' : ''
      listSorting['queryParam']['sort'] = (sortingColumn) && sortingColumn.id + sortingType
      if (listSorting.setSortType) {
        if(listSorting['queryParam']['sort']==undefined&&sortType){
          listSorting['queryParam']['sort']=sortType;
        }else{
          if(listSorting['queryParam']['sort']&&listSorting['queryParam']['sort']!==undefined){
            listSorting.setSortType(listSorting['queryParam']['sort'])
          }
        }
      }
      dispatch(listSorting.asyncMethod(listSorting));
    }
  }, [dispatch, productType, activePage, searchKey, offset,sortType])

  const upDateData = (data, id, value) => { }


  /* CSV file imoport block */

  /* Aborting upload */
  const controller = new AbortController()
  const signal = controller.signal

  /* Cancel upload function */
  // const cancelUpload = () => {
  //   // Abort.
  //   controller.abort()
  //   setFileSelected(false)
  //   dispatch(setUploadStatus(null))
  // }

  /* State to check weather the CSV file is selected or not */
  const [fileSelected, setFileSelected] = useState(false)

  /* Handle file import */
  const handleImport = (data) => {
    /* If file selected, set state as true */
    /* Check if the selected file is CSV or not */
    const fileName = data.target.files[0].name.split('.')
    if (fileName[fileName.length - 1] === 'csv'||fileName[fileName.length - 1] === 'xlsx'||fileName[fileName.length - 1] === 'xls') {
      setFileSelected(true)
      /* Initilize formdata */
      let payload = new FormData();
      // Add file to formdata
      payload.append(
        'csv',
        data.target.files[0]
      );
      /* Dispatch payload and abort signal */
      dispatch(fileUplodad({ payload, signal, getPatientList, getCustomerList, getUserList }))
      /* Reset the form */
      data.target.value = ''
    } else {
      /* If it is not a csv file error */
      // alert('Wrong file type selected!!!')
      alert('The import file must be either Excel (xls) or CSV (csv) format')
    }
  }

  // const [getFormImport, setGetFormImport] = useState()
  // const handleImportFormulary = (data) => {
  //   /* If file selected, set state as true */
  //   /* Check if the selected file is CSV or not */
  //   const fileName = data.target.files[0].name.split('.')
  //   if (fileName[fileName.length - 1] === 'csv'||fileName[fileName.length - 1] === 'xlsx'||fileName[fileName.length - 1] === 'xls') {
  //     setFileSelected(true)
  //     /* Initilize formdata */
  //     let payload = new FormData();
  //     // Add file to formdata
  //     payload.append(
  //       'csv',
  //       data.target.files[0]
  //     );
  //     /* Dispatch payload and abort signal */    
  //     // setGetFormImport(payload)
  //     dispatch(fileUplodad({ payload, signal, getPatientList, getCustomerList, getUserList }))      
  //     /* Reset the form */
  //     data.target.value = ''
  //   } else {
  //     /* If it is not a csv file error */
  //     // alert('Wrong file type selected!!!')
  //     alert('The import file must be either Excel (xls) or CSV (csv) format')
  //   }
  // }

  // const handleUploadFormulary = () => {
  //   // dispatch(fileUplodad({ getFormImport, signal, getPatientList, getCustomerList, getUserList }))
  // }

  /* Loader close */
  const loaderClose = () => {
    setFileSelected(false)
    dispatch(setUploadStatus(null))
  }

  /* Check weather someone else is uploading */
  const [uploading, setUploading] = useState(false)
  const uploadingPatient = useSelector((state) => state?.patient?.uploading)
  const uploadingCustomer = useSelector((state) => state?.customer?.uploading)
  const uploadingUSer = useSelector((state) => state?.user?.uploading) 

  useEffect(()=>{
    if(path=== `${origin}/admin/patients`){
      setUploading(uploadingPatient)
    }
    if(path=== `${origin}/admin/customers`){
      setUploading(uploadingCustomer)
    }
    if(path=== `${origin}/admin/users`){
      setUploading(uploadingUSer)
    }
  },[path])

  // window.onload = function() {  
  //   if(!fileSelected) {
  //     if (path === `${origin}/admin/patients` || path === `${origin}/admin/customers` || path === `${origin}/admin/users`) {
  //       dispatch(uploadingCheckAsync())
  //     }      
  //   }
  // }

  useEffect(()=>{
    if(!fileSelected) {
      if (path === `${origin}/admin/patients` || path === `${origin}/admin/customers` || path === `${origin}/admin/users`) {
        dispatch(uploadingCheckAsync())
      }      
    }
  },[path])
  
  /* For set interval timer */
  const [intervalId, setIntervalId] = useState(0) 
  useEffect(() => {
    /* If no file is selected keep on calling API to check if someone is uploading,
      if someone is uploaidng, we need to disable the "import" button */
    let interval;
    // if (!fileSelected) {
    //   if (path === `${origin}/admin/patients` || path === `${origin}/admin/customers` || path === `${origin}/admin/users`) {
    //     interval = setInterval(() => {
    //       dispatch(uploadingCheckAsync())
    //     }, process.env.REACT_APP_UPLOADING_CHECK_INTERVAL)
    //     /* Assigning it to state */
    //     setIntervalId(interval)
    //   }
    // }

    /* If not in list view clear interval */
    if (path !== `${origin}/admin/patients` || path !== `${origin}/admin/customers` || path !== `${origin}/admin/users`) {
      clearInterval(intervalId)
    }
    /* If we are uploading, we should not call above API */
    if (fileSelected) {
      clearInterval(intervalId)
    }
    return () => {
      clearInterval(interval)
    }
  }, [fileSelected, dispatch])

  let listModalBox = {
    'Patients': isAdminView ? <CreatePatients modalOpen={modalShow} modalClose={modalClose} facilityListView={facilityListView} /> :
      <SimpleCreatePatient modalOpen={modalShow} modalClose={modalClose} selectedFacility={(selectedFacility) ? selectedFacility : ''} getPatientList={getPatientList} facilityListView={facilityListView}/>,
    'Customers': isAdminView ? <CreateCustomer modalOpen={modalShow} modalClose={modalClose} setSearchColumns={setSearchColumns} setSearchKey={setSearchKey} setActivePage={setActivePage}/> : '',
    'Users': isAdminView ? <CreateUser modalOpen={modalShow} modalClose={modalClose} /> : '',
    'Sso': isAdminView ? <CreateSso modalOpen={modalShow} modalClose={modalClose} /> : '',
    'FormBuilder': <CreateForm modalOpen={modalShow} modalClose={modalClose} />,
    'Announcement': <CreateAnnouncement modalOpen={modalShow} modalClose={modalClose} />
  }

  let headerProp = {
    'Patients': {
      heading: `${isAdminView ? otherHeading ? 'Patient Management' : 'Admin Portal' : 'Patients'}`,
      patientView: patientView,
      // subHeading: `${isAdminView ? 'Patient Management' : ''}`
    },
    'Customers': {
      heading: 'Admin Portal',
      subHeading: subHeading
    },
    'Users': {
      heading: 'Admin Portal',
      subHeading: 'Users Profile'
    },
    'Sso': {
      heading: 'Admin Portal',
      subHeading: 'SSO'
    },
    'FormBuilder': {
      heading: 'Admin Portal',
      subHeading: 'Form Builder'
    },
    'Announcement': {
      heading: 'Admin Portal',
      subHeading: 'Announcement'
    },
    'Layouts': {
      heading: 'Admin Portal',
      subHeading: 'Layout'
    },
    'ContextualSupport': {
      heading: 'Admin Portal',
      subHeading: 'Contextual Support'
    },
    'Formulary': {
      heading: 'Admin Portal',
      subHeading: 'Formulary'
    },
    'Products': {
      heading: 'Admin Portal',
      // subHeading: (productType === "material") ? 'Material' : (productType === "productfamily") ? 'Product Family' :''
      subHeading: 'Products'
    },
  }

  let listMenu = {
    'Layouts': <CreateListViewMenu menuList={menuShow} dropRef={dropRef} />
  }
  let productMaterialCreateMenu = {
    'Products': <CreateProductMaterial menuList={menuShow} dropRef={dropRef} setProductType={setProductType}/>
  }

  // const getCustomerNumber = (value) => {
  //   if (value) {
  //      setErrorMsg('')
  //     // setonselectOrg([])
  //    // setCustomerNumber(value)
  //     dispatch(getFacilityDataAsyncForPatients({ customerNumber: value},setCustomerNumber));
  //     // dispatch(setFacilityAndCustomerNumLastVal({
  //     //   customerNum  : value,
  //     //   facilitylocation : facilityAndCustomerNumLastVal.facilitylocation ? facilityAndCustomerNumLastVal.facilitylocation  : ''
  //     // }))setFacilityAndCustomerNumLastVal
  //   }
  // }
  
  const imagePlusIcon = <img src={PlusIcon} className={`${style.plusimg}`} alt="Click to add" />

  const getShowClearX = (e) => {
    if (e?.target?.value) {
      setShowClearX(true)
      return e.target.value=e?.target?.value.replace(/(\s{2,})/g, ' ').replace(/^\s*/, '')
    }else{
      setShowClearX(false)
    }
  }
  // const [showClearXCust, setShowClearXCust] = useState(patientListLastVal?.customerNumber?true:false)
  // const getShowClearXCust = (e) => {
  //   if (e?.target?.value) {
  //     setShowClearXCust(true)
  //     return e.target.value=e?.target?.value.replace(/(\s{2,})/g, ' ').replace(/^\s*/, '')
  //   }else{
  //     setShowClearXCust(false)
  //   }
  // }

  const [excelHoverOption, setExcelHoverOption] = useState(false)
  const [createManualOption, setCreateManualOption] = useState(false)
  const [existingOption, setExistingOption] = useState(false)
  const [showPopup, setShowPopup] = useState(false)  

  const onClickFormulary = () => {
    setShowPopup(true)
  }

  const nextFormularyScreen = () => {
    let formularyName = document.getElementById('formularyName').value;
    const payloadCheckBackEnd = { formularyName: formularyName.charAt(0).toUpperCase() + formularyName.slice(1).toLowerCase()}
    dispatch(checkFormularyNameStatus(payloadCheckBackEnd, navigate)) 
    setFormularyNamePopup(formularyName.charAt(0).toUpperCase() + formularyName.slice(1).toLowerCase())    
    if(formularyName !== ""){      
      onLoadFormularySuccess();
    }
    else{
      setErrorMsgFor("please enter any account number")
    } 
  }

  const checkFormularyName = useSelector((state)=>state?.formulary?.formularyNameCheck)
  const onLoadFormularySuccess = () => {
    if(checkFormularyName && formularyNamePopup !== ""){
      setShowFormOption(true)
      setShowPopup(false);       
      setFormularyChanged(false) 
      dispatch(setFormularyNameCheck(false))
    }
    else{
      setErrorMsgFor("A formulary for this account already exists. Please search for the existing formulary and select 'Edit' to make changes.")
    } 
  }

  const [formularyChanged, setFormularyChanged] = useState(false)
  const changeFormularyName= (value) => {
    setShowFormOption(false)
    setFormularyNamePopup(value)
    setShowPopup(true) 
    setFormularyChanged(true)   
  }

  const formularyRef = useRef();
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideForumulary);
    return () => document.removeEventListener('mousedown', handleClickOutsideForumulary);
  });

  const handleClickOutsideForumulary = (e) => {
    if (formularyRef !== null && formularyRef.current && !formularyRef.current.contains(e.target)) {
      setShowFormOption(false);      
    }
  };
  
  
  // const [showImportPopup, setShowImportPopup] = useState(false)
  
  const clickCopyExisting = () => {
    setDuplicateNavigate(true)
  }

   /* CustomerNumber search Suggestions  */   
   const [custNumInput, setCustNumInput] = useState("");
   const [isSelect, setIsSelect] = useState(false);
   const searchTerm = useDebounce(custNumInput, 500);
   const [errorMsgFor, setErrorMsgFor] = useState("")

   const customerNumberSearchDatas = useSelector(
       (state) => state.user.customerNumberSearch
     );

 
   useEffect(() => {
       if (!isSelect && searchTerm && searchTerm.length >= 1) {
         dispatch(getCustomerNumberSuggestions(searchTerm));
       } else {
         dispatch(setCustomerNumberSearch({}));
       }
     }, [searchTerm]);

     const [checkOrgDrop, setCheckOrgDrop] = useState(false)
     const getCustomerNumberFormulary = (val) => {         
      dispatch(setUserFacilities([])) 
  
      if(val === ''){
        setErrorMsgFor("please enter any account number")
      }
      else{ 
          setErrorMsgFor('')     
          const payload = { customer: val }
          dispatch(getFaciltiestUserAsyn(payload,setCheckOrgDrop,setErrorMsgFor));                   
      }       
  }

  const getCustomerNumberSearch = (event) => {  
    if(event === ''){
        setErrorMsgFor("please enter any account number")
        setCustNumInput("")
    }else {    
        setErrorMsgFor('')   
        setIsSelect(false);    
        setCustNumInput(event)                 
    }  
  };  

  const customerNumberSelect = (e, items) => {
    e.stopPropagation();  
    setIsSelect(true);
    dispatch(setCustomerNumberSearch({}));              
    if (items) {
      setErrorMsgFor('')       
      const customerNumber = items;
      setCustNumInput(customerNumber);
      document.getElementById("formularyName").value = customerNumber;
      document.getElementById("formularyName").value = items; 
      setFormularyNamePopup(customerNumber.charAt(0).toUpperCase() + customerNumber.slice(1).toLowerCase())             
      const payload = { customer: items }
      dispatch(getFaciltiestUserAsyn(payload, setCheckOrgDrop));  
      let formularyName = customerNumber.charAt(0).toUpperCase() + customerNumber.slice(1).toLowerCase();
      const payloadCheckBackEnd = { formularyName: formularyName.toString()}
      dispatch(checkFormularyNameStatus(payloadCheckBackEnd, navigate))     
    }   
  }


  return <>
    {/* {!formularyView && !duplicateNavigate &&  <Header {...headerProp[listType]} />} */}
    
    <div className={`col pt-0 pr-0 pb-3`}>
      <div className={`row ${style.ipadm_l}`}>
        {!formularyView && <>
        
          {(listType === 'Customers')&&
            <SelectBox
                id={"searchSelectbox"}
                name={"searchSelectbox"}
                classes={{
                    column: `col-15 h-33 w-175 ${style.col_spec}`,
                    inputClassName: style.searchBarSelect,
                    inputColumn: `col-15 p-0 ${style.searchPos}`
                }}
                optionValue={[
                { key: 'customerNumber', value: 'Customer #' },
                { key: 'customerName', value: 'Customer name' },
                ]}
              //selectedData={searchColumns.includes(columnDatas)}
              //searchColumns
                defaultValue={searchColumns?searchColumns:''}
                onChange = {(e) => handleSearchColumn(e)}
          />
        }
        
        <TextField
          classes={{
            column: `form-group no-gutters ${commonStyle.form_group} position-relative ${listType === 'Patients' ? 'col-sm-4' : 'col-sm-7'} p-0 ${duplicateNavigate && 'pt-3'}`,
            inputClassName: `form-control mb-1 ${style.pl40} `,
            labelClass: `position-absolute ${style.search_icon_image} ${duplicateNavigate && 'pt-3'}`
          }}
          label={<img src={searchIcon} alt="search icon" />}
          type={"text"}
          name={"search"}
          id={"search"}
          dataTestId={"search"}
          placeholder={isPending ? "Searching..." : searchPlaceholder}
          title={'Toggle All Rows Selected'}
          onKeyUp={getSearchValue}
          defaultValue={searchKey?searchKey.trim():searchKey}
          getSearchValue={getSearchValue}
          onChange={getShowClearX}
          showClearX={showClearX}
          setShowClearX={setShowClearX}
          duplicateNavigate={duplicateNavigate}

        />
         
          {(listType === 'Products') &&
            <div className="ml-3" key={productType}>
              <RadioButton
                id={"productType"}
                name={"productType"}
                classes={{
                  labelClass: `custom-control-label col-form-label ${style.custom_control_label}`,
                  inputClassName: `custom-control-input ${style.custom_control_input} productType`,
                  inputColumn: `custom-control custom-radio custom-control-inline`
                }}
                radioOption={['Product Family','Material']}
                defaultValue={(productType && productType === 'material') ? 'Material' : 'Product Family'}
                onChange={handleProductChange}
              />
            </div>
          }     
          {/* Pending & Locked Button */}     
          {(listType === 'Users') && <div className='ml-3'>   
            <button
                id={"pending-btn"}
                key={'index0'}
                className = {openPend === true ? ` ${style.btn_addextrahover} mr-3 toggleBtn` : ` ${style.btn_addextra} mr-3 toggleBtn`}
                onClick={() => pendingList()}
                value="A-D"
              >
                Pending Approval
            </button>
            <button
                id={"locked-btn"}
                key={'index1'}
                className = {openLock === true ? ` ${style.btn_addextrahover} toggleBtn` : ` ${style.btn_addextra} toggleBtn`}
                onClick={() => lockedList()}
                value="E-H"
              >
                Account Locked
            </button>                
          </div>} 
          {/* Pending & Locked Button */}

        </>
        }

        <div className={`${((productType === 'productfamily')) ? 'col-sm-12 justify-content-end' : ((productType === 'material') && Array.isArray(data) && data.length === 0) ? 'col-sm-12' : (listType === 'Patients') ? 'col-sm-8' : 'col-sm-5 justify-content-end'} d-flex pr-0`}>
          {listType === "Patients" && <div className={`${style.customer_search_parent}`}>
            <div>
              <div className={`d-flex`}>
                <SelectBox
                  id={"facility"}
                  name={"facilityFilter"}
                  classes={{ column: `pl-0 ${style.facility_pos} col-9`, labelClassName: `col-3 col-form-label p-0 `, inputColumn: `col-12 p-0  ${style.select_wrapper}`, inputClassName: `form-control ${style.basic_select}` }}
                  optionValue={Array.isArray(facOptionData)?facOptionData:[]}
                  //defaultValue = {selectedFacility}
                  defaultValue={patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:selectedFacility}
                  onChange={(e) => facilityListView(e.target.value)}
                  placeholder={'Facility/Location'}
                />
                {
                  !isAdminView && <Button
                    id={"forgot-btn"}
                        classes={{ className: `btn ${style.btn_add}`}}
                      onClick={manualPatientEnable ? () => modalOpen() : undefined}
                      disabled={!manualPatientEnable || isReadOnly}
                  >
                    {imagePlusIcon}
                    {'Add Patient'}
                  </Button>
                }
                {!isAdminView && !selectedFacility && (
                  <span className={`${style.tooltip} ${style.infoIcon}`}>
                    <img src={InfoIcon} alt="info" />
                    <span className={`${style.tooltiptext}`}>
                      {constants.patient.addPatientInfo}
                    </span> 
                </span>
                )}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      {/* {(userRole?.role !== 'ExternalAdministrator') && <div className={ userRole?.role === 'ExternalAdministrator' ? `w-100 ${style.min_height_external}` : `w-100 ${style.min_height}`}> */}
      {<div className={userRole?.role === 'ExternalAdministrator' ? `w-100 ${style.min_height_external}` : `w-100 ${style.min_height}`}>
          {Array.isArray(data) && data.length > 0 && isAdminView && !contextualSupportView && !formularyView && !duplicateNavigate && (productType !== 'productfamily') && listType !== "Patients" &&  <div className={userRole?.role !== 'ExternalAdministrator' ? `pt-4 d-inline-block` : `pt-4 d-inline-block mb-3`}>
            {<span id='selectedRowCount' className={userRole?.role !== 'ExternalAdministrator' ? 'font-weight-bold  pl-4': 'd-none'}>{`${selectedRowCount} Selected`}</span>}
            {selectedRowCount > 0 && userRole?.role !== 'ExternalAdministrator' && <div className={style.del_block} onClick={() => deleteModal()}>
              <img src={DeleteIcon} alt="delete" id="delete_icon" />Delete
            </div>}
          </div>}
          {Array.isArray(data) && data.length > 0 && isAdminView && listType === "Patients" &&  <div className={`pt-4 d-inline-block`}>
            {<span id='selectedRowCount' className='font-weight-bold  pl-4'>{`${selectedRowCount} Selected`}</span>}
            {selectedRowCount > 0 && <div className={style.del_block} onClick={() => deleteModal()}>
              <img src={DeleteIcon} alt="delete" id="delete_icon" />Delete
            </div>}
          </div>}
          {Array.isArray(data) && data.length > 0 && isAdminView && productType === "productfamily" && <div className={`pt-4 d-inline-block`}>
            <div></div>
          </div>}
          <div className="d-inline-block float-right">
            <div className="d-flex">
              {/* Added condition not to display import button for formulary */}
              {/* File import, first checking weather the role of the user */}
              {isAdminView && userRole?.role !== 'ExternalAdministrator' && !contextualSupportView && listType !== 'FormBuilder' && listType !== 'Announcement' && listType !== 'Layouts' && listType !== 'Formulary' && listType !== 'Products' && listType !== 'Sso' ? <CsvImport uploading={uploading} handleImport={handleImport} /> : ''}

              {/* If we started uploaing display the modal with loader */}
              {fileSelected && userRole?.role !== 'ExternalAdministrator' && !contextualSupportView && listType !== 'FormBuilder' && listType !== 'Announcement' && listType !== 'Layouts' && listType !== 'Formulary' && listType !== 'Products' && listType !== 'Sso' && <CsvImportLoader modalOpen={fileSelected} modalClose={loaderClose} listType={listType} />}
              <div className="createitem_block">
                <div className="btn-group">
                  {!contextualSupportView && !formularyView && isAdminView && !duplicateNavigate &&
                    <Button
                      id={"forgot-btn"}
                      classes={{ className: userRole?.role !== 'ExternalAdministrator' ? `btn ${style.btn_add}` : `btn ${style.btn_add} mb-3` }}
                      onClick={(listType === 'Products') ? () => menuList() : (listType === 'Layouts') ? () => menuList() : listType === 'Formulary' ? () => onClickFormulary() : () => modalOpen()}
                    >
                      {imagePlusIcon}
                      {(listType === 'Patients') ? 'Add Patient' : ''}
                      {(listType === 'Customers') ? 'New Customer' : ''}
                      {(listType === 'Users') ? 'Create User' : ''}
                      {(listType === 'Sso') ? 'New' : ''}
                      {(listType === 'FormBuilder') ? 'Create Form' : ''}
                      {(listType === 'Announcement') ? 'Create Item' : ''}
                      {(listType === 'Layouts') ? 'Create New' : ''}
                      {(listType === 'Formulary') ? 'New Formulary' : ''}
                      {(listType === 'Products') ? 'New' : ''}
                    </Button>
                  }
                  <div>
                    {
                      listMenu && <div>{listMenu[listType]}</div>
                    }
                  </div>
                  <div>
                    {
                      productMaterialCreateMenu && <div>{productMaterialCreateMenu[listType]}</div>
                    }
                  </div>
                </div>              
                

              </div>
            </div>
          </div>
      </div>
    }      
    </div>

    {showPopup && 
      <Modal
          modalOpen={showPopup}
          // modalClose={()=>setShowPopup(false)}
          // modalClose={modalClose}
          // heading={"Create Item"}
          className={"modal_box"}
          modalSize={style.custom_modal_size}
          custom_heading={style.custom_modal_size_import_heading}
          reset={reset}
      >
        <div className={`${style.accNumFormularyPopup}`}>
            <div className='pt-3 pb-4'>
              <span data-testid="cancelFormularyPopup" onClick={()=>{setShowPopup(false);setErrorMsgFor('');setFormularyChanged(false)}}>
                <i className="fa fa-times" aria-hidden="true" style={{color:'#000', float:'right', fontSize:'1.5rem', marginRight:'7px', marginTop:'-24px', opacity:'0.5', cursor:'pointer'}}></i>
              </span>
            </div>
            {/* <h1>Enter the account number</h1> */}
            <h1>Enter the account number or the group number</h1>
            <p>Tip: If the formulary remains consistent across the organization, use the primary group number</p>
            <div className="col-12 m-auto text-center py-4">
                <TextField
                  classes={{
                    column: `form-group col-12 p-0 ${style.field_max}`,
                    labelClass: `font-weight-bold ${style.label_spec}`,
                    inputClassName: `form-control mb-1 ${style.textFormularyName}`,
                    inputColumn: "col-12 p-0",
                  }}
                  // label={"Formulary Name:"}
                  type={"text"}
                  name={"formularyName"}
                  id={"formularyName"}
                  dataTestId={"formularyName"}
                  // placeholder={"Account Number"}
                  // validator={register({
                  //   required: "Please enter formulary name",
                  // })}                          
                    errors={errors}
                    customError={errorMsgFor ? errorMsgFor : ""}
                    // customError={
                    //     editState?.errorMessage && errCk?.data===null
                    //       ? editState.errorMessage
                    //       : customerNumberSearchDatas &&
                    //         Array.isArray(customerNumberSearchDatas) &&
                    //         customerNumberSearchDatas.length === 0
                    //       ? "Customer Number is not found"
                    //       : ""
                    //   }
                    required={true}
                    validator={register()} 
                    // validator={register({
                    //     validate: (value,e) => {
                    //       if ((value === ""|| value === null)&&(traveNurse === 0)) {
                    //         return "Customer Number Required"
                    //       } 
                    //       return true                             
                    //     }
                    //   })}                       
                    defaultValue={formularyChanged ? formularyNamePopup : ''}                                                   
                    onKeyPress={()=>{
                        setErrorMsgFor('')
                    }}
                    onChange={(e)=>getCustomerNumberSearch(e.target.value)}                        
                    onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          getCustomerNumberFormulary(e.target.value);
                        }
                    }} 
                />
                {customerNumberSearchDatas &&
                    Array.isArray(customerNumberSearchDatas) &&
                    customerNumberSearchDatas.length > 0 && (
                        <div className="col-12 col-spec row">
                          <div className={`col_spec ${style.search_drop}`}>
                            <div className={`col-spec ${style.search_close_box}`}>
                            {customerNumberSearchDatas.map(
                                (items) =>
                                items && (
                                    <p
                                    key={items}
                                    className={`dropdown-item`}
                                    title={items.value}
                                    onClick={(e) => customerNumberSelect(e, items)}
                                    >
                                    {items}
                                    </p>
                                )
                            )}
                            </div>
                        </div>
                        </div>
                    )} 
              </div>
              <div className='pt-1 pb-3'>
                <Button
                  classes={{
                    className: `btn ${style.btn_custom_continue}`,
                  }}
                  type="Save"
                  onClick={()=>nextFormularyScreen()}
                  // onClick={() => {setShowFormOption(true);setShowPopup(false)}}
                >
                  {"Next"}
                </Button>                    
              </div>
              {/* <div className=''>
                <Button
                  classes={{
                    className: `btn ${style.btn_custom}`,
                  }}
                  type="button"
                  onClick={() => setShowPopup(false)}
                >
                  {'Cancel'}
                </Button>
              </div> */}
        </div>
        
      </Modal>
    }

{showFormOption && 
    <Modal
      modalOpen={showFormOption}
      // modalClose={()=>setShowFormOption(false)}
      // modalClose={modalClose}
      // heading={"Create Item"}
      className={"modal_box"}
      modalSize={style.custom_modal_size}
      custom_heading={style.custom_modal_size_import_heading}
      reset={reset}
    >                
    <div className={`${style.navManualPopup}`}>
      <div className='pb-4'>
        <div className='pt-3 pb-4'>
          <span data-testid="changeFormularyId" onClick={()=>{changeFormularyName(formularyNamePopup); setErrorMsgFor('')}}>
            <i className="fa fa-times" aria-hidden="true" style={{color:'#000', float:'right', fontSize:'1.5rem', marginRight:'7px', marginTop:'-24px', opacity:'0.5', cursor:'pointer'}}></i>
          </span>
        </div>
        {/* <div className='d-flex'> */}
        <h1>Formulary for {formularyNamePopup}<span className='' style={{color:'#0052cc', cursor:'pointer', marginLeft:'10px'}} onClick={()=>changeFormularyName(formularyNamePopup)}>Change</span></h1>
        {/* </div> */}
      </div>
        <div 
          className={`${style.importExcelSection}`} 
          onMouseOver={()=>{setExcelHoverOption(true)}} 
          onMouseLeave={()=>{setExcelHoverOption(false)}}
          onClick={()=>clickImportExcel()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 17.906 16.853">
              <path d="M14.684 56.77a2.607 2.607 0 0 0-.991-.612v4.056h4.056a2.583 2.583 0 0 0-.612-.99l-2.453-2.454zm-2.044 4.5V56H4.213v8.426H0v1.054h4.213v7.373h13.693V61.267H12.64zm-4.367 7.5-.745-.745 2.545-2.546H5.267v-1.053h4.806l-2.545-2.544.745-.745 3.816 3.816-3.816 3.817z" transform="translate(0 -56)" style={{fill: !excelHoverOption ? '#505f79' : '#ffffff'}}/>
          </svg>
          <p style={{alignItems:'baseline', paddingTop:'1px', paddingLeft:'5px', fontSize: '15px'}}>Import from excel </p>                        
        </div>
        <div 
          className={`${style.createManualSection}`} 
          onMouseOver={()=>{setCreateManualOption(true)}} 
          onMouseLeave={()=>{setCreateManualOption(false)}}
          onClick={()=>clickManualCreation()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 19.943 19.94">
              <path data-name="Union 1" d="M0 19.94V3.307h13.02L6.493 9.821l-.444.443v3.627h3.627l.443-.444 6.514-6.527v13.02zm7.56-7.56v-1.485l7.6-7.585 1.552-1.549 1.469 1.469-1.55 1.553-7.584 7.6zm9.743-11.213.865-.862a1.043 1.043 0 0 1 .761-.3 1.043 1.043 0 0 1 .746.34 1.047 1.047 0 0 1-.048 1.45l-.851.846z" style={{fill: !createManualOption ? '#505f79' : '#ffffff'}}/>
          </svg>
          <p style={{alignItems:'baseline', paddingTop:'1px', paddingLeft:'5px', fontSize: '15px'}}>Create manually </p>                                                         
        </div>
        <div 
          className={`${style.copyExistingSection} pl-3`} 
          onMouseOver={()=>{setExistingOption(true)}} 
          onMouseLeave={()=>{setExistingOption(false)}}
          onClick={()=>clickCopyExisting()}
        >
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 17.906 16.853">
              <path d="M14.684 56.77a2.607 2.607 0 0 0-.991-.612v4.056h4.056a2.583 2.583 0 0 0-.612-.99l-2.453-2.454zm-2.044 4.5V56H4.213v8.426H0v1.054h4.213v7.373h13.693V61.267H12.64zm-4.367 7.5-.745-.745 2.545-2.546H5.267v-1.053h4.806l-2.545-2.544.745-.745 3.816 3.816-3.816 3.817z" transform="translate(0 -56)" style={{fill: !excelHoverOption ? '#505f79' : '#ffffff'}}/>
          </svg> */}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 48 48">
            <path d="M 18.5 5 C 15.480226 5 13 7.4802259 13 10.5 L 13 32.5 C 13 35.519774 15.480226 38 18.5 38 L 34.5 38 C 37.519774 38 40 35.519774 40 32.5 L 40 10.5 C 40 7.4802259 37.519774 5 34.5 5 L 18.5 5 z M 18.5 8 L 34.5 8 C 35.898226 8 37 9.1017741 37 10.5 L 37 32.5 C 37 33.898226 35.898226 35 34.5 35 L 18.5 35 C 17.101774 35 16 33.898226 16 32.5 L 16 10.5 C 16 9.1017741 17.101774 8 18.5 8 z M 11 10 L 9.78125 10.8125 C 8.66825 11.5545 8 12.803625 8 14.140625 L 8 33.5 C 8 38.747 12.253 43 17.5 43 L 30.859375 43 C 32.197375 43 33.4465 42.33175 34.1875 41.21875 L 35 40 L 17.5 40 C 13.91 40 11 37.09 11 33.5 L 11 10 z" style={{fill: !existingOption ? '#505f79' : '#ffffff'}}/>
          </svg>
          <p style={{alignItems:'baseline', paddingTop:'1px', paddingLeft:'5px', fontSize: '15px'}}>Copy from existing </p>                        
        </div>
      </div>
    </Modal>      
  }

    {/* {showImportPopup && 
      <Modal
        modalOpen={showImportPopup}
        modalClose={()=>{setShowImportPopup(false)}}
        heading={"Import Formulary"}
        className={"modal_box"}
        modalSize={style.custom_modal_size_import}
        custom_heading={style.custom_modal_size_import_heading}
        reset={reset}
      >
        <div className={`${style.import_top_content} mt-3`}>
          <div className='pt-5 pb-4'>
            <span>
              <i className="fa fa-plus" aria-hidden="true" style={{color:'#0052cc', fontSize:'30px'}}></i>
            </span>
          </div>
          <div className='py-5'>
            <button
              className={`${style.btn_browse}`}
              type="button"
              // onClick={()=>saveFormularyName()}
              // onClick={() => handleImport()}
              >
              <label htmlFor="csv">Browse</label>
              <input
              type="file"
              id="csv"
              className={style.file_upload}
              accept=".csv, .xls, .xlsx, text/csv, application/csv,
                    text/comma-separated-values, application/csv, application/excel,
                    application/vnd.msexcel, text/anytext, application/vnd. ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleImportFormulary}
            />
            </button>                    
          </div>          
        </div>
        <div className={`${style.import_bottom_content} d-flex justify-content-around align-items-center`}>              
            <div className=''>
              <Button
                classes={{
                  className: `btn ${style.btn_cancel_import}`,
                }}
                type="cancel"
                // onClick={()=>saveFormularyName()}
                onClick={() => {setShowImportPopup(false)}}
              >
                {"Cancel"}
              </Button>                    
            </div>
            <div className=''>
              <Button
                classes={{
                  className: `btn ${style.btn_save_import}`,
                }}
                type="save"
                onClick={handleUploadFormulary}
              >
                {'Upload'}
              </Button>
            </div>
          </div>
      </Modal>  
    } */}

  {
      patientLoad && listType === 'Patients'?<div style={{ minHeight: '300px',display:'flex',justifyContent:'center' }} className={`text-center mt-2 mb-3`}>
      <img src={Loader} alt="loader" style={{ maxWidth: '50px' }} />
    </div>:<>
    
    {
      data && listType === 'Patients'&& <>
        <div className={`${style.loader_parent}`}>
          {/* {loading && <div className={`text-center mt-2 mb-3 ${style.loader_child}`}>
            <img src={Loader} alt="loader" style={{ maxWidth: '50px' }} />
          </div>} */}
          <DataTable
            columns={columns}
            data={data}
            sorting={sorting}
            rowSelect={rowSelect}
            getSelectedRowData={getSelectedRowData}
            setSelectedRows={selectRowCount}
            saveData={upDateData}
            onSort={(listType === 'Products') ? handleProductSort : rightFormulary ? handleRightSort : handleSort}
            detailView={detailView}
            deleteDataList={deleteDataList}
            showFixedColumn={showFixedColumn}
            searchKey={searchKey}
            listType={listType}
            formularyView={formularyView}
            formularyLeft={formularyLeft}
            productType={productType}
            fixedFullWidthSize={fixedFullWidthSize}
            activePage={activePage}
            sortType={sortType}
          />
          {(!noPage) && (Array.isArray(data)) && (data.length > 0) && <Pagination
            activePage={activePage}
            itemsCountPerPage={metaData ? metaData.limit : 50}
            totalItemsCount={metaData ? metaData.total : 0}
            getActivePage={getActivePage}
            formularyView={formularyView}
          />}
        </div>
      </>
    }
    
    </>
    }
    {
      data &&listType !== 'Patients'&& <>
        <div className={`${style.loader_parent}`}>
          {/* {loading && <div className={`text-center mt-2 mb-3 ${style.loader_child}`}>
            <img src={Loader} alt="loader" style={{ maxWidth: '50px' }} />
          </div>} */}
          <DataTable
            columns={columns}
            data={data}
            sorting={sorting}
            rowSelect={rowSelect}
            getSelectedRowData={getSelectedRowData}
            setSelectedRows={selectRowCount}
            saveData={upDateData}
            onSort={(listType === 'Products') ? handleProductSort : rightFormulary ? handleRightSort : handleSort}
            detailView={detailView}
            deleteDataList={deleteDataList}
            showFixedColumn={showFixedColumn}
            searchKey={searchKey}
            listType={listType}
            formularyView={formularyView}
            formularyLeft={formularyLeft}
            productType={productType}
            fixedFullWidthSize={fixedFullWidthSize}
            activePage={activePage}
            sortType={sortType}
            filterOnclick={filterOnclick}
            duplicateNavigate={duplicateNavigate}
            handleClearFilter={handleClearFilter}
            enableClearFilter={enableClearFilter}
          />
          {(!noPage) && (Array.isArray(data)) && (data.length > 0) && <Pagination
            activePage={activePage}
            itemsCountPerPage={metaData ? metaData.limit : 50}
            totalItemsCount={metaData ? metaData.total : 0}
            getActivePage={getActivePage}
            formularyView={formularyView}
          />}
        </div>
      </>
    }
    {
      listModalBox[listType]
    }
    {
      confirmationModal && <Confirmation
        onClose={() => modalClose()}
        title={" "}
      >
        <div className="text-center pr-5 pl-5">
          <p>
            <img src={warning} alt="warnning-icon" />
          </p>
          <p className="pb-3">Are you sure you’d like to delete Items?</p>
          <div className="mb-2">
            <Button
              value="Yes"
              classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${style.yes_btn}` }}
              onClick={() => deleteList()}
            />
            <Button
              id="closeId"
              value="No"
              classes={{ className: `btn ml-2 pb-2 pt-2 ${style.no_btn}` }}
              onClick={() => modalClose()}
            />
          </div>
        </div>
      </Confirmation>
    }
    {
      accessError && !modalShow && <AccessErrorModal />
    }
  </>
}
